import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicDropdownService {

  /****************** Variable declaration ******************/
  /**Subject */
  private dataSubject = new Subject<any>();
  private booleanVal = new BehaviorSubject<any>(undefined);
  private resetSearchSubject = new Subject<void>();

  /**Api url and api's */
  public configApis = this.apiService.CONFIG_BUILDER_APIS;
  public wfEventURL = this.apiService.KPID_URL + this.configApis.WF_EVENT;

  public dataMap: any = {}

  headers = new HttpHeaders({ "isLoader": "true" })

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(private httpClient: HttpClient,
    private apiService: ApiService) { }

  /** Load data is used to load the data received from the request */
  loadData(data: any) {
    this.dataMap = data
  }

  /** check if the object is empty */
  isObjEmpty(obj: any = {}) {
    return Object.keys(obj).length === 0;
  }


  /** getPayload is used to trigger an api call to get the payload details */
  getPayload(eventId: number) {
    return this.httpClient.get(this.wfEventURL + this.configApis.GET_PAYLOAD(eventId), { headers: this.headers });
  }

  /** Send data to any component */
  sendData(data: any) {
    this.dataSubject.next(data);
  }

  /** getData is used to fetch data to service */
  getData() {
    return this.dataSubject.asObservable();
  }

  /** sendBoolData is to send a boolean value */
  sendBoolData(data: any) {
    this.booleanVal.next(data);
  }

  /** getBoolData is to fetch data */
  getBoolData() {
    return this.booleanVal.asObservable();
  }

  /** Broadcast a reset signal so every dynamic-recursive-menu instance
   *  clears its local search term (called when the dropdown is reopened). */
  resetSearches() {
    this.resetSearchSubject.next();
  }

  /** Observable that emits whenever searches should be reset */
  onResetSearches() {
    return this.resetSearchSubject.asObservable();
  }
}
